import { render, staticRenderFns } from "./CartItemTable.vue?vue&type=template&id=0d508d37&"
import script from "./CartItemTable.vue?vue&type=script&lang=ts&"
export * from "./CartItemTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports